import { render } from "./MakeBlock.vue?vue&type=template&id=310b8df6&scoped=true"
import script from "./MakeBlock.vue?vue&type=script&lang=js"
export * from "./MakeBlock.vue?vue&type=script&lang=js"

import "./MakeBlock.vue?vue&type=style&index=0&id=310b8df6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-310b8df6"

export default script